import { createSelector } from 'reselect'

const surpriseBoxState = (state) => state.surpriseBox

export const getData = createSelector(surpriseBoxState, (s) => s?.data || [])
export const getIsLoaded = createSelector(surpriseBoxState, (s) => s?.isLoaded || false)
export const getIsSubmitting = createSelector(surpriseBoxState, (s) => s?.isSubmitting || false)
export const getPage = createSelector(surpriseBoxState, (s) => s?.page || 1)
export const getPerPage = createSelector(surpriseBoxState, (s) => s?.perPage || 50)
export const getTotal = createSelector(surpriseBoxState, (s) => s?.total || 0)
export const getStatus = createSelector(surpriseBoxState, (s) => s?.status || '')
export const getCurrentPromotion = createSelector(surpriseBoxState, (s) => s?.currentPromotion || null)
